import { Button } from "@clockwise/design-system";
import { TextResponseTypeEnum } from "@clockwise/schema";
import { TrackingEvents, useTracking } from "@clockwise/web-commons/src/util/analytics.util";
import React from "react";
import { useUpdateShowMemoryModal } from "../../../chat-plus-calendar/util/MemoryModalContext";
import { FeedbackThumbs } from "../../web/FeedbackThumbs";
import { textSplitByNewLine } from "../utils/textSplitByNewLine";
import { GQLAssistantMessageTextResponse } from "../utils/types";

export const TextResponse = ({
  message,
  currentLLMUsed,
}: {
  message: GQLAssistantMessageTextResponse;
  currentLLMUsed: string;
}) => {
  const track = useTracking();
  const updateShowMemoryModal = useUpdateShowMemoryModal();
  const setShowMemory = () => {
    updateShowMemoryModal(true);
    track(TrackingEvents.CHAT.MEMORY.MEMORY_MODAL_VIEWED);
  };

  const showMemory = message.type === TextResponseTypeEnum.MEMORY;
  // Don't show feedback thumbs for confirming message
  const showFeedbackThumbs = message.text !== "Confirming...";
  return (
    <div className="cw-flex-col cw-items-start cw-body-sm">
      {textSplitByNewLine(message.text)}
      {showMemory && (
        <div className="cw-mt-3">
          <Button onClick={setShowMemory} variant="outlined" size="small">
            Edit Memory
          </Button>
        </div>
      )}
      {showFeedbackThumbs && (
        <div className="cw-mt-3">
          <FeedbackThumbs
            msgId={message.id}
            conversationId={message.conversationId}
            orientation="horizontal"
            currentLLMUsed={currentLLMUsed}
          />
        </div>
      )}
    </div>
  );
};
